import { LOAD_PATHS } from '../../../../helpers/api/apiPaths';

export const get = (resource, id) => {
  const suffix = (id) ? `/${id}` : '';

  return LOAD_PATHS[resource] + suffix;
};



// WEBPACK FOOTER //
// ./src/reducers/middleware/resourceResolver/resourcePath/resourcePath.js